import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import FeaturesSection from './components/FeaturesSection';
import StatsSection from './components/StatsSection';
import MobileAppSection from './components/MobileAppSection';
import CTASection from './components/CTASection';

export default function HomePage() {
  return (
    <div className="bg-background-50">
      <HeroSection />
      <ServicesSection />
      <FeaturesSection />
      <StatsSection />
      <MobileAppSection />
      <CTASection />
    </div>
  );
}